import { supabase } from './supabase';

/**
 * Check if the current user is whitelisted for a specific feature/extension
 */
export async function isUserWhitelisted(extensionId: string): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    return false;
  }

  const { data, error } = await supabase.rpc('is_user_whitelisted', {
    p_extension_id: extensionId
  });

  if (error) {
    console.error('Error checking whitelist:', error);
    return false;
  }

  return data === true;
}
